import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const ListHolidayRoutes = [
  {
    path: '/list-holidays',
    name: 'ListListHolidays',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'holiday_group:list'
    }
  },
  {
    path: '/list-holiday/',
    name: 'CreateListHoliday',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'holiday_group:create'
    }
  },
  {
    path: '/list-holiday/:id',
    name: 'UpdateListHoliday',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'holiday_group:update'
    }
  },
  {
    path: '/list-holiday/view/:id',
    name: 'GetListHoliday',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'holiday_group:get'
    }
  }
]
